var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showModal
    ? _c(
        "section",
        {
          staticClass: "vn-modal vn-modal--md vn-modal--system",
          class: { "vn-modal--invert": !_vm.isDark },
          attrs: { id: "system-modal" },
          on: { click: _vm.closeModal },
        },
        [
          _c(
            "div",
            {
              staticClass: "vn-modal__box",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c("h2", { staticClass: "vn-modal__h" }, [
                _vm._v(_vm._s(_vm.title)),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "vn-modal__p" }, [
                _vm._v(_vm._s(_vm.message)),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "vn-modal__cont" },
                [_c("icon-error-system")],
                1
              ),
              _vm._v(" "),
              _vm.confirm
                ? _c("div", { staticClass: "vn-modal__func btn__flex" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn--md",
                        attrs: { type: "button" },
                        on: { click: _vm.closeModal },
                      },
                      [_vm._v("확인")]
                    ),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }